// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiApplicationKindSchema = z.enum(['AGENT','MCP_SERVER'] as const);

export type AiApplicationKindType = `${z.infer<typeof AiApplicationKindSchema>}`

export default AiApplicationKindSchema;
